var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.$style.wrapper},[_c('div',{class:[_vm.$style.dot, _vm.status ? _vm.$style.dotGreen : _vm.$style.dotRed]}),_c('span',{class:_vm.$style.status},[_vm._v(" "+_vm._s(_vm.status ? 'En cours' : 'Terminé')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }